import type { LucideIcon } from "lucide-react";
import {
  FilePen,
  FolderOpen,
  CalendarDays,
  Target,
  ClipboardList,
  BarChart3,
  Settings2,
  LayoutDashboard,
  Bell,
} from "lucide-react";

export type SubItem = { label: string; to: string };
export type MenuGroup = {
  label: string;
  icon: LucideIcon;
  to?: string;
  items?: SubItem[];
};

export const MENU: MenuGroup[] = [
  { label: "Tổng quan", icon: LayoutDashboard, to: "/dashboard" },
  {
    label: "Văn bản Ký điện tử",
    icon: FilePen,
    items: [
      { label: "Trình Ký", to: "/signs/trinh-ky" },
      { label: "Ký duyệt", to: "/signs/ky-duyet" },
      { label: "Ký nháy", to: "/signs/ky-nhay" },
      { label: "Ban Hành", to: "/signs/ban-hanh" },
      { label: "Thảo luận văn bản", to: "/signs/thao-luan" },
      { label: "Văn bản đơn vị", to: "/signs/don-vi" },
    ],
  },
  {
    label: "Quản lý Văn bản",
    icon: FolderOpen,
    items: [
      { label: "Văn bản đơn vị", to: "/documents/org-tree" },
      { label: "Văn bản cá nhân", to: "/documents" },
      { label: "Văn bản đến", to: "/documents/incoming" },
      { label: "Văn bản đi", to: "/documents/outgoing" },
      { label: "Bộ hồ sơ", to: "/documents/records" },
      { label: "Công bố văn bản", to: "/documents/published" },
      { label: "Thư viện văn bản", to: "/documents/library" },
    ],
  },
  {
    label: "Quản lý lịch họp",
    icon: CalendarDays,
    items: [
      { label: "Lịch họp cá nhân", to: "/meetings/personal" },
      { label: "Lịch họp đơn vị", to: "/meetings/org" },
      { label: "Quản lý phòng họp", to: "/meetings/rooms" },
      { label: "Biên bản họp", to: "/meetings/minutes" },
    ],
  },
  {
    label: "Quản lý nhiệm vụ",
    icon: Target,
    items: [{ label: "Danh sách nhiệm vụ", to: "/tasks" }],
  },
  {
    label: "Quản lý công việc",
    icon: ClipboardList,
    items: [
      { label: "Theo dõi yêu cầu", to: "/work/requests" },
      { label: "Tổng hợp công việc", to: "/work/summary" },
      { label: "Công việc Phòng ban", to: "/work/dept" },
      { label: "Tự đánh giá HQCV", to: "/work/self-review" },
      { label: "Quản lý đánh giá", to: "/work/reviews" },
    ],
  },
  {
    label: "Thông báo",
    icon: Bell,
    to: "/notifications",
  },
  {
    label: "Báo cáo",
    icon: BarChart3,
    items: [
      { label: "Thực hiện CV – BC01", to: "/reports/bc01" },
      { label: "Kế hoạch CV – BC11", to: "/reports/bc11" },
      { label: "Xã hội nhân viên", to: "/reports/staff" },
    ],
  },
  {
    label: "Quản trị",
    icon: Settings2,
    items: [
      { label: "Danh sách người dùng", to: "/admin/users" },
      { label: "Danh sách vai trò", to: "/admin/roles" },
      { label: "Danh sách đơn vị", to: "/admin/orgs" },
      { label: "Danh sách nhóm cá nhân", to: "/admin/groups" },
      { label: "Luồng ký mẫu", to: "/admin/sign-flows" },
      { label: "Lịch sử hoạt động", to: "/admin/activity-log" },
      { label: "Cấu hình AI", to: "/admin/ai-config" },
      { label: "Sử dụng AI", to: "/admin/ai-usage" },
    ],
  },
];
